import { render, staticRenderFns } from "./FormatCreate.vue?vue&type=template&id=02bdabd9"
import script from "./FormatCreate.vue?vue&type=script&lang=js"
export * from "./FormatCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports